import * as angular from "angular";
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsCommands} from "../../shared/dto/aps.commands";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import NotificationsName, {Notifications, NotificationsConstructable} from "../../models/notifications/notifications";
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";
import { CronJob, job } from "cron";

let requires = [HttpServiceName, NotificationsName];

export interface NotificationService {
  getNotifications(shopId: string,
                   roleId: string,
                   shift: apsEnums.Shift,
                   $window: angular.IWindowService,
                   $scope: angular.IScope): angular.IPromise<Notifications>;
  readNotification(notificationId: string): angular.IPromise<any>;
  completeNotification(notificationId: string, comment: string): angular.IPromise<any>;
  sendNotification(notification: apsCommands.SendGlobalNotification): angular.IPromise<any>;
  sendReleaseNotesNotification(notification : apsCommands.AddReleaseNoteNotification);
  getReleaseNotesNotification();
  setCronJob1(cron: CronJob);
  stopCronJob1();
  setCronJob2(cron: CronJob);
  stopCronJob2();
  setCronJob3(cron: CronJob);
  stopCronJob3();  
}

class NotificationSvcImpl implements NotificationService {
  private httpService: HttpService;
  /* tslint:disable:variable-name */
  private Notifications: NotificationsConstructable;
  /* tslint:enable:variable-name */
  private cron1: CronJob;
  private cron2: CronJob;
  private cron3: CronJob; 

  constructor(httpService: HttpService,
              /* tslint:disable:variable-name */
              Notifications: NotificationsConstructable) {
              /* tslint:enable:variable-name */
    this.httpService = httpService;
    this.Notifications = Notifications;
  }
  setCronJob1(cron: CronJob){
    if (this.cron1){
      this.cron1.stop();
    }
    this.cron1 = cron;
    this.cron1.start();
  }
  stopCronJob1()  {
    if (this.cron1){
      this.cron1.stop();
    }
  }
  setCronJob2(cron: CronJob){
    if (this.cron2){
      this.cron2.stop();
    }
    this.cron2 = cron;
    this.cron2.start();
  }
  stopCronJob2()  {
    if (this.cron2){
      this.cron2.stop();
    }
  }
  setCronJob3(cron: CronJob){
    if (this.cron3){
      this.cron3.stop();
    }
    this.cron3 = cron;
    this.cron3.start();
  }
  stopCronJob3()  {
    if (this.cron3){
      this.cron3.stop();
    }
  }  
  getNotifications(shopId: string,
                   roleId: string,
                   shift: apsEnums.Shift,
                   $window: angular.IWindowService,
                   $scope: angular.IScope): angular.IPromise<Notifications> {
    return this.httpService.get(Endpoints.NOTIFICATION, {
      shopId: shopId,
      roleId: roleId,
      shift: shift
    }).then((data: apsViewModels.NotificationItem[]) => {
      return new this.Notifications(data, this, $window, $scope);
    });
  }

  readNotification(notificationId: string): angular.IPromise<any> {
    return this.httpService.post(Endpoints.NOTIFICATION_READ, {
      id: notificationId
    });
  }

  completeNotification(notificationId: string, comment: string): angular.IPromise<any> {
    return this.httpService.post(Endpoints.NOTIFICATION_COMPLETE, {
      id: notificationId,
      comment: comment
    });
  }

  sendNotification(notification: apsCommands.SendGlobalNotification): angular.IPromise<any> {
    return this.httpService.post(Endpoints.NOTIFICATION_SEND, notification);
  }

  sendReleaseNotesNotification(notification : apsCommands.AddReleaseNoteNotification) {
    return this.httpService.post(Endpoints.RELEASE_NOTE_NOTIFICATION_SEND, notification);
  }

  getReleaseNotesNotification(){
    return this.httpService.get(Endpoints.GET_RELEASE_NOTE_NOTIFICATION);
  }
}

export default angular
  .module('aps.services.notification', requires)
  .service('notificationService', NotificationSvcImpl)
  .name;



// WEBPACK FOOTER //
// ./src/app/services/notifications/notification.service.ts